import React from 'react';
import * as styles from './RateDisclosures.module.scss';
import { isString } from 'lodash';
import classNames from 'classnames';
import { format } from 'fecha';
import { isValidDate } from '@helpers';

export default function RateDisclosure({ effectiveDate }) {
  const disclosures = [];

  if (effectiveDate) {
    if (!isValidDate(effectiveDate)) {
      effectiveDate = new Date();
    }

    try {
      const dateString = format(effectiveDate, 'MMMM Do, YYYY');
      const timeString = format(effectiveDate, 'h:mm A');

      disclosures.push(
        <p
          key="date"
          className={styles.effectiveDate}
        >
          Rates and terms effective as of {dateString} at {timeString} and are
          subject to change without&nbsp;notice.
        </p>
      );
    } catch (error) {
      console.error(error);
    }
  }

  return !disclosures.length ? null : (
    <div
      className={classNames(
        'content-wrapper',
        'calculator-rate-disclosure',
        styles.wrapper
      )}
    >
      {disclosures.map((d, index) => {
        return !isString(d) ? d : <p key={index}>{d}</p>;
      })}
    </div>
  );
}
